import type { IconSvgObject } from './types';

const ArrowRight04Icon: IconSvgObject = [
  ["path", { d: "M14 12H4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 11.9996L14 16L14 8L20 11.9996Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowRight04Icon;
